export const loadReCaptcha = () => {
    const render = () => {
        if (window.grecaptcha) {
            window.grecaptcha.ready(() => {
                window.grecaptcha.render('inline-recaptcha-badge', {
                    sitekey: '6Lf2_K4ZAAAAAB6hJ-f8E0K0TsA5zYJQjKeID0TI',
                    badge: 'bottomleft',
                    size: 'invisible'
                });
            });
        }
    };

    loadDynamicScript(
        render,
        'reCaptcha',
        'https://www.google.com/recaptcha/api.js?render=explicit'
    );
};

export const loadBambooOpenPosition = (callback) => {
    loadDynamicScript(callback, 'bamboo', 'https://salesscreen.bamboohr.com/js/embed.js');
};

const loadDynamicScript = (callback, id, url) => {
    const existingScript = document.getElementById(id);
    if (!existingScript) {
        const script = document.createElement('script');
        script.src = url;
        script.id = id;
        document.body.appendChild(script);

        script.onload = () => {
            if (callback) callback();
        };
    }

    if (existingScript && callback) callback();
};

export const pushBingAdsUETEvent = (action, category, label) => {
    // /* BING ADS */
    window.uetq = window.uetq || [];
    window.uetq.push('event', action, {
        event_category: category,
        event_label: label
    });
};


export const trackFacebookConversions = () => {
    if (window.fbq) {
        window.fbq('track', 'Lead');
    }
};

export const trackFacebookContentDownloadConversions = (title) => {
    if (window.fbq) {
        window.fbq('track', 'ViewContent', { content_name: title });
    }
};

export const trackLinkedInSignupConversion = () => {
    let pid = 602756;
    let conversionId = 5846753;

    var imgtag = document.createElement('img');
    imgtag.height = '1';
    imgtag.width = '1';
    imgtag.style = 'border-style:none;';
    imgtag.alt = '';
    imgtag.src = `https://px.ads.linkedin.com/collect/?pid=${pid}&conversionId=${conversionId}&fmt=gif`;

    document.body.append(imgtag);
};

export const trackLinkedInDownloadContentConversion = () => {
    let pid = 602756;
    let conversionId = 5846761;

    var imgtag = document.createElement('img');
    imgtag.height = '1';
    imgtag.width = '1';
    imgtag.style = 'border-style:none;';
    imgtag.alt = '';
    imgtag.src = `https://px.ads.linkedin.com/collect/?pid=${pid}&conversionId=${conversionId}&fmt=gif`;

    document.body.append(imgtag);
};

export const trackLinkedIDownloadContentNoBarrierConversion = () => {
    let pid = 602756;
    let conversionId = 3771353;

    var imgtag = document.createElement('img');
    imgtag.height = '1';
    imgtag.width = '1';
    imgtag.style = 'border-style:none;';
    imgtag.alt = '';
    imgtag.src = `https://px.ads.linkedin.com/collect/?pid=${pid}&conversionId=${conversionId}&fmt=gif`;

    document.body.append(imgtag);
};

export const trackLinkedInWebinarSignupConversion = () => {
    let pid = 602756;
    let conversionId = 5846769;

    var imgtag = document.createElement('img');
    imgtag.height = '1';
    imgtag.width = '1';
    imgtag.style = 'border-style:none;';
    imgtag.alt = '';
    imgtag.src = `https://px.ads.linkedin.com/collect/?pid=${pid}&conversionId=${conversionId}&fmt=gif`;

    document.body.append(imgtag);
};
